"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var styled_components_1 = __importDefault(require("styled-components"));

var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: white;\n  width: 50px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 22px;\n  display: flex;\n  padding: 4px;\n  align-items: center;\n  cursor: pointer;\n  font-family: \"Nunito Sans\", sans-serif;\n"], ["\n  background-color: white;\n  width: 50px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 22px;\n  display: flex;\n  padding: 4px;\n  align-items: center;\n  cursor: pointer;\n  font-family: \"Nunito Sans\", sans-serif;\n"])));
var Circle = styled_components_1.default("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 20px;\n  transition: all 0.2s ease-in-out;\n  transform: ", ";\n  svg {\n    transition: all 0.2s ease-in-out;\n    fill: ", ";\n  }\n"], ["\n  height: 20px;\n  transition: all 0.2s ease-in-out;\n  transform: ", ";\n  svg {\n    transition: all 0.2s ease-in-out;\n    fill: ", ";\n  }\n"])), function (props) {
  return props.on ? "translatex(22px)" : "none";
}, function (props) {
  return props.on ? "#2D4EF5" : "#E5E5E5";
});

exports.Switch = function (_a) {
  var _b = _a.on,
      on = _b === void 0 ? true : _b,
      className = _a.className;
  return react_1.default.createElement(Container, {
    className: className
  }, react_1.default.createElement(Circle, {
    on: on
  }, react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24"
  }, react_1.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12"
  }))));
};

exports.Switch.propTypes = {
  on: prop_types_1.default.bool
};
var templateObject_1, templateObject_2;